import millify from "millify";
import type { MillifyOptions } from "millify/dist/options";

const formatAmount = (
  amount: string | number,
  options: Partial<MillifyOptions> | null = null,
): string => {
  return millify(Number(amount), {
    locales: "fr-FR",
    precision: 1,
    space: true,
    ...options,
  });
};

export default formatAmount;
